export const spinnerLoadingSelector = (state: any) => state.spinnerReducer.loading;